export default __webpack_public_path__ + "static/media/finance-private.4c928713.svg";